import React from "react";
import {Navbar,Footer} from '../hrcomponents';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import {useParams,Link,useNavigate, useLocation} from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { format } from "date-fns";
import { monthList, empGrade } from '../utils/datalist';
import { Modal, Button, Form, Tabs, Tab } from "react-bootstrap";

const EmployeeInfo=()=>{

    if(localStorage.getItem('branchID')===null){
        window.location.replace('/hris');
    }

    const navigate=useNavigate();
    const location = useLocation();

    const [empData,setEmpData]=useState([]);
    const [branches,setBranches]=useState([]);
    const [designations,setDesignations]=useState([]);
    const [filter, setFilter] = useState(empData);
    const [empSearch,setEmpSearch]=useState();

    const [inputData,setInputData]=useState([]);    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    

    useEffect(() => {
        const getEmpData = async () => {
          const response=await axios.get(configData.SERVER_URL+`/empData/${localStorage.getItem('branchID')}`)
          setEmpData(await response.data);
          setFilter(await response.data);

          const res=await axios.get(configData.SERVER_URL+`/branches`);
          setBranches(res.data);

          const resDesig=await axios.get(configData.SERVER_URL+`/designations`);
          setDesignations(resDesig.data);
        };
        getEmpData();
  
    }, []);

    const setEmpID=(empID)=>{
        setInputData({...inputData,['empID']:empID});
    }

    const handleInput=(e)=>{
        const {name,value}=e.target; 
        setInputData({...inputData,[name]:value});  
    }

    const handleSubmit_Tr =async(e) => {
        e.preventDefault(); 
        try {
            let res=await axios.post(configData.SERVER_URL+`/transferInsert`,inputData);
            if(res.status===200){
                alert(res.data.message);
            } 
            } catch (error) {
            console.error('System error:', error);
        } 
        handleClose();
    };

    const handleSubmit_Pro =async(e) => {
        e.preventDefault(); 
        try {
            let res=await axios.post(configData.SERVER_URL+`/promotionInsert`,inputData);
            if(res.status===200){
                alert(res.data.message);
            } 
            } catch (error) {
            console.error('System error:', error);
        } 
        handleClose();
    };

    const filterEmployee=(e)=>{
    setEmpSearch(e.target.value.toLowerCase());
    const updatedList = empData.filter((emp) => 
        emp.empCode.toLowerCase().includes(empSearch)||
        emp.empName.toLowerCase().includes(empSearch)
    );
    setFilter(updatedList);
  }

    return (
  <>
    <div className="container-fluid" >

      {/* Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        marginTop="50"
      >
        <Modal.Header
          closeButton
          style={{
            background:
              "linear-gradient(135deg,#0d6efd,#6610f2)",
            color: "#fff",
          }}
        >
          <Modal.Title className="fw-bold">
            Transfer / Promotion History
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{
            backgroundColor: "#f8f9fa",
          }}
        >
          <Tabs
            defaultActiveKey={"transfer"}
            className="mb-3"
            fill
          >
            {/* Transfer */}
            <Tab
              eventKey="transfer"
              title="Transfer Entry"
            >
              <Form onSubmit={handleSubmit_Tr}>
                <div className="row g-3">
                  <div className="col-lg-6">
                    <Form.Label className="fw-semibold">
                      Transfer Date
                    </Form.Label>

                    <Form.Control
                      type="date"
                      id="dateOf_Tr_Pro"
                      name="dateOf_Tr_Pro"
                      value={
                        inputData.dateOf_Tr_Pro
                      }
                      onChange={handleInput}
                      required
                      style={{
                        borderRadius: "10px",
                        height: "45px",
                      }}
                    />
                  </div>

                  <div className="col-lg-6">
                    <Form.Label className="fw-semibold">
                      Transfer Branch
                    </Form.Label>

                    <Form.Select
                      id="branchID"
                      name="branchID"
                      value={inputData.branchID}
                      onChange={handleInput}
                      required
                      style={{
                        borderRadius: "10px",
                        height: "45px",
                      }}
                    >
                      <option value="">
                        Select Branch
                      </option>

                      {branches.map((data) => (
                        <option
                          key={data.id}
                          value={data.id}
                        >
                          {data.branchName}
                        </option>
                      ))}
                    </Form.Select>
                  </div>

                  <div className="col-12">
                    <Form.Label className="fw-semibold">
                      Description
                    </Form.Label>

                    <Form.Control
                      type="text"
                      id="remarks"
                      name="remarks"
                      placeholder="Enter remarks..."
                      value={inputData.remarks}
                      onChange={handleInput}
                      style={{
                        borderRadius: "10px",
                        height: "45px",
                      }}
                    />
                  </div>

                  <div className="col-12">
                    <Button
                      variant="success"
                      type="submit"
                      className="px-4 py-2"
                      style={{
                        borderRadius: "10px",
                        fontWeight: "600",
                      }}
                    >
                      <Icon.ArrowLeftRight className="me-2" />
                      Submit Transfer
                    </Button>
                  </div>
                </div>
              </Form>
            </Tab>

            {/* Promotion */}
            <Tab
              eventKey="promotion"
              title="Promotion Entry"
            >
              <Form onSubmit={handleSubmit_Pro}>
                <div className="row g-3">
                  <div className="col-lg-6">
                    <Form.Label className="fw-semibold">
                      Promotion Date
                    </Form.Label>

                    <Form.Control
                      type="date"
                      id="dateOfPro"
                      name="dateOfPro"
                      value={inputData.dateOfPro}
                      onChange={handleInput}
                      required
                      style={{
                        borderRadius: "10px",
                        height: "45px",
                      }}
                    />
                  </div>

                  <div className="col-lg-6">
                    <Form.Label className="fw-semibold">
                      Designation
                    </Form.Label>

                    <Form.Select
                      id="desigID"
                      name="desigID"
                      value={inputData.desigID}
                      onChange={handleInput}
                      required
                      style={{
                        borderRadius: "10px",
                        height: "45px",
                      }}
                    >
                      <option value="">
                        Select Designation
                      </option>

                      {designations.map((data) => (
                        <option
                          key={data.id}
                          value={data.id}
                        >
                          {data.desigName}
                        </option>
                      ))}
                    </Form.Select>
                  </div>

                  <div className="col-lg-6">
                    <Form.Label className="fw-semibold">
                      Grade
                    </Form.Label>

                    <Form.Select
                      id="grade"
                      name="grade"
                      value={inputData.grade}
                      onChange={handleInput}
                      required
                      style={{
                        borderRadius: "10px",
                        height: "45px",
                      }}
                    >
                      <option value="">
                        Select Grade
                      </option>

                      {empGrade.map(
                        (empgrade) => (
                          <option
                            key={empgrade.id}
                            value={
                              empgrade.id
                            }
                          >
                            {empgrade.name}
                          </option>
                        )
                      )}
                    </Form.Select>
                  </div>

                  <div className="col-lg-6">
                    <Form.Label className="fw-semibold">
                      Description
                    </Form.Label>

                    <Form.Control
                      type="text"
                      id="proRemarks"
                      name="proRemarks"
                      placeholder="Enter remarks..."
                      value={
                        inputData.proRemarks
                      }
                      onChange={handleInput}
                      style={{
                        borderRadius: "10px",
                        height: "45px",
                      }}
                    />
                  </div>

                  <div className="col-12">
                    <Button
                      variant="primary"
                      type="submit"
                      className="px-4 py-2"
                      style={{
                        borderRadius: "10px",
                        fontWeight: "600",
                      }}
                    >
                      <Icon.GraphUpArrow className="me-2" />
                      Submit Promotion
                    </Button>
                  </div>
                </div>
              </Form>
            </Tab>
          </Tabs>
        </Modal.Body>
      </Modal>

      {/* Employee Card */}
      <div
        className="card border-0 shadow-lg"
        style={{
          borderRadius: "20px",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          className="card-header"
          style={{
            background:
              "linear-gradient(135deg,#198754,#20c997)",
            padding: "20px",
            color: "#fff",
          }}
        >
          <div className="row align-items-center g-3">
            <div className="col-lg-4 col-md-6">
              <div className="input-group">
                <span className="input-group-text bg-white border-0">
                  <Icon.Search />
                </span>

                <input
                  type="text"
                  className="form-control border-0 shadow-none"
                  placeholder="Search employee..."
                  value={empSearch}
                  onChange={(e) =>
                    filterEmployee(e)
                  }
                  style={{
                    height: "45px",
                  }}
                />
              </div>
            </div>

            <div className="col-lg-8 col-md-6 text-end">
                <button
                  type="button"
                  className="btn btn-light shadow-sm"
                  style={{
                    borderRadius: "12px",
                    padding:
                      "10px 18px",
                    fontWeight: "600",
                  }}
                  disabled={location?.state?.menu?.isInsert !== "Y"}
                  onClick={() => navigate("/hris/addEmployee")}
                >
                  <Icon.PersonPlusFill className="me-2" />
                  Add Employee
                </button>
              {/* </Link> */}
            </div>
          </div>
        </div>

        {/* Body */}
        <div
          className="card-body"
          style={{
            backgroundColor: "#f8f9fa",
            padding: "25px",
          }}
        >
          <div className="table-responsive">
            <table className="table table-hover table-bordered align-middle">
              <thead
                style={{
                  backgroundColor: "#198754",
                  color: "#fff",
                }}
              >
                <tr>
                  <th>SL</th>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Grade</th>
                  <th>Department</th>
                  <th>Category</th>
                  <th>Date of Join</th>
                  <th
                    className="text-center"
                    width={140}
                  >
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {filter &&
                  filter.length > 0 &&
                  filter.map(
                    (data, index) => (
                      <tr
                        key={data.id}
                      >
                        <td>
                          {index + 1}
                        </td>

                        <td className="fw-semibold">
                          {
                            data.empCode
                          }
                        </td>

                        <td>
                          {
                            data.empName
                          }
                        </td>

                        <td>
                          {
                            data.desigName
                          }
                        </td>

                        <td>
                          <span className="badge bg-primary px-3 py-2">
                            {
                              data.grade
                            }
                          </span>
                        </td>

                        <td>
                          {
                            data.deptName
                          }
                        </td>

                        <td>
                          <span className="badge bg-success px-3 py-2">
                            {
                              data.empCategoryName
                            }
                          </span>
                        </td>

                        <td>
                          {data.dateOfJoin &&
                          data.dateOfJoin !==
                            "0000-00-00"
                            ? format(
                                new Date(
                                  data.dateOfJoin
                                ),
                                "dd-MM-yyyy"
                              )
                            : ""}
                        </td>

                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-2">
                            {/* Edit */}
                            <button
                              type="button"
                              className="btn btn-info btn-sm"
                              style={{ borderRadius: "10px" }}
                              disabled={location?.state?.menu?.isUpdate !== "Y"}
                              onClick={() => navigate(`/hris/employeeEdit/${data.id}`)}
                            >
                              <Icon.PencilFill />
                            </button>

                            {/* Transfer/Promotion */}
                            <button
                              type="button"
                              className="btn btn-warning btn-sm"
                              style={{
                                borderRadius:
                                  "10px",
                              }}
                              onClick={() => {
                                handleShow();
                                setEmpID( data.id );
                              }}
                              disabled={location?.state?.menu?.isInsert !== "Y"}
                            >
                              <Icon.PersonLinesFill />
                            </button>
                          </div>
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>

            {filter.length === 0 && (
              <div className="alert alert-warning text-center mt-3">
                No employee found.
              </div>
            )}
          </div>
        </div>
      </div>
      
    </div>
  </>
)

}

export default EmployeeInfo;